var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid",attrs:{"id":"ScreenLock"}},[_c('div',{staticClass:"centerAlign"},[_c('img',{attrs:{"src":_vm.logoSrc,"alt":"WGACA"}}),_vm._v(" "),_c('h1',[_vm._v("LLAMAv3")])])])}
var staticRenderFns = []

export { render, staticRenderFns }